import { checkToken } from 'modules/auth';
import { getCurrentUser } from 'modules/user';

/**
 * Constants
 */

export const INITIALIZING = 'app/INITIALIZING';
export const INITIALIZED = 'app/INITIALIZED';

/**
 * Action Creators
 */

export function init() {
  return async dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        const token = localStorage.getItem('token');
        dispatch({ type: INITIALIZING, token });

        // Check for token expiration
        if (token) {
          await Promise.all([dispatch(checkToken()), dispatch(getCurrentUser())]);
        }

        dispatch({ type: INITIALIZED, token });
        resolve(token);

      } catch (error) {
        reject(error);
        dispatch({ type: INITIALIZED, error: error.message });
      }
    });
}

/**
 * Reducer
 */

const initialState = {
  online: true,
};

export default function app(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app.js